module.exports = __webpack_public_path__ + "static/media/warning.e338514e.svg";